import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useQualiphyCancelAllClinicsEnrollMutation(options = {}) {
  return useMutation(() => {
    return http.post(HTTP_ENDPOINTS.qualiphy.cancelAllClinicsEnroll());
  }, options);
}
